import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Job } from '@kanda-libs/ks-frontend-services';

import { URLS } from 'config';
import { selectors } from 'store';

export interface PayByCardPropsHook {
  isLoading: boolean;
  job?: Job;
}

export default function usePayByCardProps(): PayByCardPropsHook {
  const { push } = useHistory();

  const job = useSelector(selectors.job.getEntity);

  const jobHasFetched = useSelector(selectors.job.getHasFetched);
  const infoHasFecthed = useSelector(selectors.jobCompanyInfo.getHasFetched);

  const isLoading = Boolean(!jobHasFetched || !infoHasFecthed);

  useEffect(() => {
    if (!job) return;
    const option = job?.customer_options?.checkout_option;
    const id = job?.id;
    if (!id) return;
    if (!option || option !== 'pay_on_card') push(URLS.job.replace(':id?', id));
  }, [job, push]);

  return { isLoading, job };
}
